import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase credentials not configured. Using localStorage fallback.');
}

// Create a real client or a dummy no-op client (so TS never sees null)
const createNoOpClient = (): SupabaseClient => {
  const handler: ProxyHandler<any> = {
    get: () => () => { console.warn('Supabase not configured'); return { data: null, error: new Error('Not configured') }; }
  };
  return new Proxy({} as any, handler);
};

export const supabase: SupabaseClient = supabaseUrl && supabaseAnonKey
  ? createClient(supabaseUrl, supabaseAnonKey)
  : createNoOpClient();

export const isSupabaseConfigured = () => !!(supabaseUrl && supabaseAnonKey);
